import dayjs from 'dayjs';
import { CreneauType } from '../../app.constants';
import { Declaration } from './declaration.model';
import { IVacation } from './vacation.interface';

export class VacationTournee implements IVacation {
  constructor(
    public debut: dayjs.Dayjs,
    public fin?: dayjs.Dayjs,
    public id?: string,
    public anomalies: Declaration[] = [],
    public type = CreneauType.TOURNEE,
    public arriveeSurSite?: dayjs.Dayjs
  ) {}

  public static hydrate(vacation: VacationTournee): VacationTournee {
    return new VacationTournee(
      dayjs(vacation.debut),
      vacation.fin ? dayjs(vacation.fin) : undefined,
      vacation.id,
      vacation.anomalies?.length > 0 ? vacation.anomalies.map(Declaration.hydrate) : [],
      vacation.type,
      vacation.arriveeSurSite ? dayjs(vacation.arriveeSurSite) : undefined
    );
  }
}
